import { Component, Input, OnChanges, ChangeDetectionStrategy } from "@angular/core";

import { BaseComponent, CheckoutService, UserService } from "@mypxplat/xplat/core";
import { addMonths } from "date-fns";
import { NgxSpinnerService } from "ngx-spinner";
import { TranslateService } from "@ngx-translate/core";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-subscription-time-meter",
  templateUrl: "subscription-time-meter.component.html",
  standalone: false,
})
export class SubscriptionTimeMeterComponent extends BaseComponent {
  public bundleTimeProgress: any;
  public bundleDaysLeft: number;
  public realDiscountEnd: Date;
  constructor(
    userService: UserService,
    public checkoutService: CheckoutService,
    private _spinner: NgxSpinnerService,
    public translate: TranslateService
  ) {
    super(userService);
  }

  ngOnInit() {
    let remaining = this.checkoutService.calculateFreeTimeProgress(this.userService.subDetails.subscription.start_date, this.userService.subDetails.subscription.end_date);
    if (this.userService.subDetails.stripe_subscription?.discount?.end) {
      let discountEndDate = new Date(this.userService.subDetails.stripe_subscription.discount.end * 1000);
      this.realDiscountEnd = addMonths(discountEndDate, 1);
    }
    if (this.userService.subDetails.subscription.bundle_time) {
      if (
        this.userService.subDetails.subscription_status == "monthly_active_coupon" &&
        this.userService.subDetails.stripe_subscription?.discount.start &&
        this.userService.subDetails.stripe_subscription?.discount.end
      ) {
        remaining = this.checkoutService.calculateFreeTimeProgress(new Date(this.userService.subDetails.stripe_subscription.discount.start * 1000), this.realDiscountEnd);
      }
      this.bundleTimeProgress = remaining.percentage;
      this.bundleDaysLeft = remaining.daysLeft;
    } else {
      this.bundleTimeProgress = remaining.percentage;
      this.bundleDaysLeft = remaining.daysLeft;
    }
  }
}
